import type {Criterion, CriterionField, ICriterionFactory, OperatorableCriterion} from '../criteria.types';
import {CRITERION_OPERATORS} from '../criterions/criterion-operators';

export default class OperatorableCriterionFactory implements ICriterionFactory<OperatorableCriterion> {

    constructor(private criterionFactory: ICriterionFactory) {
    }

    public createTextCriterion(field: CriterionField, matcher?, startsWith?) {
        return this.addOperatorAndReturn(this.criterionFactory.createTextCriterion(field, matcher, startsWith));
    }

    public createBetweenCriterion(field: CriterionField, matcher?) {
        return this.addOperatorAndReturn(this.criterionFactory.createBetweenCriterion(field, matcher));
    }

    public createEqCriterion(field: CriterionField, matcher?) {
        return this.addOperatorAndReturn(this.criterionFactory.createEqCriterion(field, matcher));
    }

    public createInCriterion(field: CriterionField, matcher?) {
        return this.addOperatorAndReturn(this.criterionFactory.createInCriterion(field, matcher));
    }

    private addOperatorAndReturn(newlyCreatedCriterion: Criterion): OperatorableCriterion {
        (newlyCreatedCriterion as OperatorableCriterion).operator = CRITERION_OPERATORS.AND;
        return (newlyCreatedCriterion as OperatorableCriterion);
    }
}
